"use client";

import { usePathname } from "next/navigation";
import Avatar from "./Avatar";
import Navbar from "./Navbar";
import SignInAndOut from "./SignIn";
import ThemeToggle from "./ThemeToggle";
import GithubIcon from "@/public/icons/GithubIcon";
import OutboundLink from "@/components/analytics/OutboundLink";

export default function Header() {
  const pathname = usePathname();
  const page = pathname.split("/").slice(0, 2).join("/");

  return (
    <header className="grid w-full grid-flow-col grid-cols-3 sm:grid-cols-4">
      <Avatar page={page} />

      <Navbar page={page} />

      <div className="flex items-center justify-end gap-2">
        <ThemeToggle />
        <OutboundLink
          href="https://github.com/xCnccw"
          location="header_github"
          className="rounded-xl p-1 text-slate-900/75 transition hover:text-slate-950 dark:text-white/75 dark:hover:text-white"
        >
          <GithubIcon className="h-8 w-8" />
        </OutboundLink>
        <SignInAndOut pathname={pathname} />
      </div>
    </header>
  );
}
